import colors from "../../../theme/colors";


export default function ImageIcon({ size }: { size?: string }) {
  return (
    <svg
      style={{
        cursor: "pointer",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
      width={size || "12"}
      height={size || "12"}
      viewBox="0 0 18 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1.6665 2.98246C1.6665 1.87789 2.56193 0.98246 3.6665 0.98246H14.3332C15.4377 0.98246 16.3332 1.87789 16.3332 2.98246V13.0175C16.3332 14.1221 15.4377 15.0175 14.3332 15.0175H3.66651C2.56194 15.0175 1.6665 14.1221 1.6665 13.0175V2.98246Z"
        stroke={colors.placeholder}
        strokeWidth="1.5"
        strokeLinejoin="round"
      />
      <path
        d="M1.6665 14.1404L10.2974 6.44103C10.9993 5.81492 12.0426 5.76246 12.8038 6.31501L16.3332 8.8772"
        stroke={colors.placeholder}
        strokeWidth="1.5"
      />
      <ellipse
        cx="5.4001"
        cy="5.6"
        rx="0.8"
        ry="0.8"
        fill={colors.placeholder}
        stroke={colors.placeholder}
      />
    </svg>
  );
}
